import { SESSION_STORAGE_TOKEN} from "@/config/comm";
import { getStore, removeStroe, setStore } from "@/utils/storage";

export const uuid = function () {
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}


/**
 * 系统工具对象
 */
export const SysUtil = {
  //返回首页
  returnIndex() {
      router.push({ name: "index" });
  },
  //系统退出
  logout(type,callback) {
      let commModal = {
          isShow: true,
          tips: `您确认要退出系统吗？`,
          okCallBack: async () => {
              exit().then(() => {
                  this.clearSysState(type);
                  if(callback && typeof callback === 'function'){
                      callback();
                  }
              });
          }
      };
      store.commit("SET_COMM_MODAL", commModal);
  },

  //清空系统状态
  clearSysState(type) {
      //移除token
      // TokenUtil.removeStoreAll();
      //移除目录记录状态
      // MenuUtil.removeMenuName();

      //清空动态路由
      store.commit("DYNAMIC_ROUTER", []);
      //清除用户信息
      store.commit("setUserInfo", {});
      //清除权限信息
      store.commit("setResRight", []);

      //头部导航信息
      store.commit("R_NAVS", []);
      //左侧菜单信息
      store.commit("R_ASIDES", []);
      //清空加载状态
      store.commit("IS_ADD_ASYNC_ROUTER", false);

      location.href = '/'
  }
};

/**
 * 与token有关的工具类
 */
export const TokenUtil = {
  getToken() {
    return getStore(SESSION_STORAGE_TOKEN);
  },
  setToken(token) {
    // token.expires_time = new Date().getTime() + token.expires_in * 1000;
    setStore(SESSION_STORAGE_TOKEN, token);
  },
  removeToken() {
    removeStroe(SESSION_STORAGE_TOKEN);
  },
  getAccessToken() {
    return this.getToken();
  },
  getJsonToken() {
    return getStore(SESSION_STORAGE_TOKEN);
  },
};


export const CardIdUtils = {
  // 根据身份证号码获取出生日期
  getBirth(idCard) {
    var birthday = "";
    if(idCard != null && idCard != ""){
        if(idCard.length == 15){
            birthday = "19"+idCard.slice(6,12);
        } else if(idCard.length == 18){
            birthday = idCard.slice(6,14);
        }
        birthday = birthday.replace(/(.{4})(.{2})/,"$1-$2-");
        //通过正则表达式来指定输出格式为:1990-01-01
    }
    return birthday;
  },
  // 根据身份证号码获取性别
  // 男：1，女：2
  // 男：0，女：1
  getSex(idCard) {
    var sexStr = '';
    if (parseInt(idCard.slice(-2, -1)) % 2 == 1) {
        // sexStr = '1';
        sexStr = '0';
    }
    else {
        // sexStr = '2';
        sexStr = '1';
    }
    return sexStr;
  },
    // 根据身份证号码获取年龄
    getAge(idCard){
        var ageDate = new Date()
        var month = ageDate.getMonth() + 1
        var day = ageDate.getDate()
        var age = ageDate.getFullYear() - idCard.substring(6, 10) - 1
        if (idCard.substring(10, 12) < month || idCard.substring(10, 12) === month && idCard.substring(12, 14) <= day) {
            age++
        }
        if (age <= 0) {
            age = 1
        }
        return age
    }
}

export const areaUtils = {
  /**
   * 获取 12 位行政区划等级
   * @param areaCode
   * @returns {number}
   */
  getLevel(areaCode) {
    if (!areaCode) return 0;
    let length = areaUtils.getVaildCode(areaCode).length;
    let level = 1;
    if (length > 0 && length <= 2) {
        //省级
        level = 1;
    } else if (length > 2 && length <= 4) {
        //市级
        level = 2;
    } else if (length > 4 && length <= 6) {
        //县级
        level = 3;
    } else if (length > 6 && length <= 9) {
        //乡级
        level = 4;
    } else if (length > 9 && length <= 12) {
        //村级
        level = 5;
    }
    return level;
  },
  getVaildCode(code) {
    let arr = code.split("").reverse();
    let c = 0;
    for (let i = 0; i < arr.length; i++) {
        if (arr[i] != "0") {
            c = i;
            break;
        }
    }
    return code.substring(0, 12 - c);
  }
}

export const dictUtil={
    setDictServeList:(listData)=>{
        const dictList=listData.map((el) => {
            return {text: el.name, value: el.code?el.code+'':el.key+''};
        });
        return dictList;
    },
    setDictStringList:(listData)=>{
        const dictList=[];
        listData.forEach((el) => {
            dictList.push( {text: el+'', value: el+''});
        });
        return dictList;
    },
}
/**
 * 手机相关判断
 */
export const phoneUtil={
    //是否是苹果手机
    IsIOS() {
        var u = navigator.userAgent;
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        return isiOS
    },
    //是否是android设备
    IsAndroid() {
        var u = navigator.userAgent;
        return u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
    },
}
